import { SVGProps } from 'react';

export const LibraryIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M2.5 8.5H13.5M2.5 11H13.5M2.5 13.5H13.5M3.75 3.5H12.25C12.9404 3.5 13.5 4.05964 13.5 4.75C13.5 5.44036 12.9404 6 12.25 6H3.75C3.05964 6 2.5 5.44036 2.5 4.75C2.5 4.05964 3.05964 3.5 3.75 3.5Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
